export enum RevenueRecognitionState {
  DRAFT = 'DRAFT',
  READY = 'READY',
  POSTED = 'POSTED',
}
